// Workhub(bitkey)のパスワードポリシーに準拠する
// 使用可能な文字: 半角英数字と記号 !"#$%&'()*+,-./:;<=>?@[\]^_{|}~
// 使用不可な文字: 半角スペース、バッククォート
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 56;

export const PASSWORD_ALLOWED_CHARS_REGEX =
  /^[a-zA-Z\d!"#$%&'()*+\-.,/:;<=>?@[\\\]^_{|}~]*$/;
